import React from 'react';

const LoginPageComponent = React.memo(() => <div />);

LoginPageComponent.displayName = 'LoginPageComponent';

export default LoginPageComponent;
